import { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import api from '@/lib/api';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const nav = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return toast.error('Mínimo 8 caracteres');
    if (password !== confirm) return toast.error('Las contraseñas no coinciden');
    if (!token) return toast.error('Enlace inválido');
    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token, password });
      toast.success('Contraseña actualizada');
      nav('/login', { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'No se pudo restablecer');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center p-6 bg-background">
      <form onSubmit={submit} className="surface w-full max-w-md p-8 space-y-4">
        <h1 className="font-display text-2xl font-semibold">Nueva contraseña</h1>
        <p className="text-sm text-muted-foreground">Elige una contraseña segura para tu cuenta.</p>
        <label className="block">
          <span className="text-xs text-muted-foreground">Contraseña</span>
          <input type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} className="input mt-1" autoFocus />
        </label>
        <label className="block">
          <span className="text-xs text-muted-foreground">Confirmar</span>
          <input type="password" required minLength={8} value={confirm} onChange={(e) => setConfirm(e.target.value)} className="input mt-1" />
        </label>
        <button type="submit" disabled={loading} className="btn-primary w-full">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
          Guardar
        </button>
        <Link to="/login" className="text-xs text-primary block text-center">Volver al login</Link>
      </form>
    </div>
  );
}
